import { useState, type ReactNode } from "react";

import DeliveryMessage from "./deliveryMessage";
import LogisticsTracking from "./logisticsTracking";
import PayHistory from "./payHistory";
import ProveMaterial from "./proveMaterial";
import type { TradeOrderData } from "../TradeOrderComponentPrimitives";

export interface DeliveryDetailProps {
    data?: TradeOrderData;
    payHistory?: TradeOrderData[];
    tracking?: TradeOrderData[];
    materials?: TradeOrderData[];
    showPayHistory?: boolean;
    headerContent?: ReactNode;
    onTabChange?: (tab: string) => void;
    onEdit?: (data: TradeOrderData) => void;
    onCancel?: (data: TradeOrderData) => void;
    onInitiate?: (data: TradeOrderData) => void;
    onDelete?: (data: TradeOrderData) => void;
    children?: ReactNode;
}

/** 提货详情组合组件，按旧版页签切换真实提货、收款、凭证和物流内容。 */
export default function DeliveryDetail({
    data = {},
    payHistory = [],
    tracking = [],
    materials = [],
    showPayHistory = true,
    headerContent,
    onTabChange,
    onEdit,
    onCancel,
    onInitiate,
    onDelete,
    children
}: DeliveryDetailProps) {
    const [activeTab, setActiveTab] = useState("delivery");
    const tabItems = [
        ["delivery", "提货信息"],
        ["payment", "收款记录"],
        ["material", "凭证材料"],
        ["tracking", "物流跟踪"]
    ].filter(([key]) => showPayHistory || key !== "payment");
    const selectTab = (tab: string) => {
        setActiveTab(tab);
        onTabChange?.(tab);
        document.getElementById(`trade-delivery-${tab === "delivery" ? "message" : tab}`)?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    const tabs = (
            <div className="mb-4 flex gap-4 border-b">
                {tabItems.map(([key, label]) => (
                    <button
                        key={key}
                        type="button"
                        className={activeTab === key ? "border-b-2 border-blue-500 pb-2" : "pb-2"}
                        onClick={() => selectTab(key)}
                    >
                        {label}
                    </button>
                ))}
            </div>
        );
    const content = (
        <>
            <div id="trade-delivery-message">
                <DeliveryMessage data={data} onCancel={onCancel} onDelete={onDelete} onEdit={onEdit} onInitiate={onInitiate} />
            </div>
            {showPayHistory ? (
                <div id="trade-delivery-payment">
                    <PayHistory items={payHistory} />
                </div>
            ) : null}
            <div id="trade-delivery-material">
                <ProveMaterial items={materials} />
            </div>
            <div id="trade-delivery-tracking">
                <LogisticsTracking items={tracking} />
            </div>
            {children}
        </>
    );
    if (headerContent) {
        return (
            <>
                <section className="section-card mb-2">
                    {headerContent}
                    {tabs}
                </section>
                <div className="trade-delivery-detail-content">{content}</div>
            </>
        );
    }
    return (
        <section className="section-card mb-4">
            <div className="section-title">提货详情</div>
            {tabs}
            {content}
        </section>
    );
}
